import { render } from "./AppStatica.vue?vue&type=template&id=7b6a68e7&scoped=true"
import script from "./AppStatica.vue?vue&type=script&lang=js"
export * from "./AppStatica.vue?vue&type=script&lang=js"

import "./AppStatica.vue?vue&type=style&index=0&id=7b6a68e7&lang=css"
import "./AppStatica.vue?vue&type=style&index=1&id=7b6a68e7&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6a68e7"]])

export default __exports__